var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4889",
    "data-name": "Rectangle 4889",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    strokeDasharray: "2 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 41,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 40.5,
    rx: 9.75,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9911",
    "data-name": "Group 9911",
    transform: "translate(22.5 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "portrait",
    d: "M5.859,14.531A.469.469,0,0,1,5.391,15H2.148A2.15,2.15,0,0,1,0,12.852V9.609a.469.469,0,0,1,.938,0v3.243a1.212,1.212,0,0,0,1.21,1.21H5.391A.469.469,0,0,1,5.859,14.531ZM.469,5.859a.469.469,0,0,0,.469-.469V2.148A1.212,1.212,0,0,1,2.148.938H5.391a.469.469,0,0,0,0-.938H2.148A2.15,2.15,0,0,0,0,2.148V5.391A.469.469,0,0,0,.469,5.859ZM12.852,0H9.609a.469.469,0,0,0,0,.938h3.243a1.212,1.212,0,0,1,1.21,1.21V5.391a.469.469,0,0,0,.938,0V2.148A2.15,2.15,0,0,0,12.852,0Zm1.679,9.141a.469.469,0,0,0-.469.469v3.243a1.212,1.212,0,0,1-1.21,1.21H9.609a.469.469,0,0,0,0,.938h3.243A2.15,2.15,0,0,0,15,12.852V9.609A.469.469,0,0,0,14.531,9.141Z",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4891",
    "data-name": "Rectangle 4891",
    width: 15,
    height: 15,
    transform: "translate(0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "id-card",
    d: "M8.185,0H1.059A1.06,1.06,0,0,0,0,1.059V5.874A1.06,1.06,0,0,0,1.059,6.933H8.185A1.06,1.06,0,0,0,9.244,5.874V1.059A1.06,1.06,0,0,0,8.185,0Zm-5.3,1.541a.963.963,0,1,1-.963.963A.964.964,0,0,1,2.889,1.541ZM4.622,5.1a.289.289,0,0,1-.289.289H1.444A.289.289,0,0,1,1.156,5.1V4.911A1.06,1.06,0,0,1,2.215,3.852H3.563A1.06,1.06,0,0,1,4.622,4.911ZM7.8,5.393H5.682a.289.289,0,1,1,0-.578H7.8a.289.289,0,0,1,0,.578Zm0-1.541H5.682a.289.289,0,1,1,0-.578H7.8a.289.289,0,0,1,0,.578Zm0-1.541H5.682a.289.289,0,1,1,0-.578H7.8a.289.289,0,0,1,0,.578Zm0,0",
    transform: "translate(2.879 4.033)",
    fill: "#8e8e8e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivUp);
export default __webpack_public_path__ + "static/media/DrivUp.04cb038559b22c2394b29b4258c874f8.svg";
export { ForwardRef as ReactComponent };